import { init as categoryInit } from './components/categoryComponent';
import { init as coreInit } from '../../core/js/components/coreComponent';
import categoryStartingSagas from './init/categoryStartingSagas';
import { configureStore } from './store';

const store = configureStore();

categoryStartingSagas.forEach((saga) => {
    store.runSaga(saga);
});

/* eslint-disable no-unused-vars */
const categoryRegistry = categoryInit(store);
const coreRegistry = coreInit(store);
/* eslint-enable no-unused-vars */

window.__store = store;
